import useDebounce from "./useDebounce"
import { useEffect, useState } from "react"
import fetch from "cross-fetch"

const EVENTS_PER_PAGE = 15

export const useEvents = (searchValues, eventType, locale) => {
  const debouncedText = useDebounce(searchValues.text, 500)

  const [events, setEvents] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(true)

  useEffect(() => {
    setLoading(true)
    setError(false)
    fetch("/.netlify/functions/events", {
      method: "POST",
      body: JSON.stringify({
        ...searchValues,
        eventType: eventType || "all",
        from: searchValues.from || new Date(0),
        to: searchValues.to || new Date(8640000000000000),
        text: debouncedText,
        locale,
      }),
    })
      .then(res => res.json())
      .then(data => {
        setEvents(
          data.events
            .map(ev => {
              if (ev.price) return ev
              ev.price = ev._allPriceLocales?.find(e => e.value)?.value || ""
              return ev
            })
            .reduce((acc, curr) => {
              if (
                acc.length === 0 ||
                acc[acc.length - 1].length >= EVENTS_PER_PAGE
              ) {
                return [...acc, [curr]]
              }
              acc[acc.length - 1].push(curr)
              return acc
            }, [])
            .map(page =>
              page.reduce((acc, curr) => {
                const entry = acc.find(
                  x => x.year === new Date(curr.startDate).getFullYear()
                )
                if (entry) {
                  entry.events.push(curr)
                } else {
                  acc.push({
                    year: new Date(curr.startDate).getFullYear(),
                    events: [curr],
                  })
                }
                return acc
              }, [])
            )
        )
      })
      .catch(() => setError(true))
      .then(() => setLoading(false))
  }, [
    locale,
    eventType,
    ...Object.values({ ...searchValues, text: debouncedText }),
  ])

  return { events, loading, error }
}
